module.exports = __webpack_public_path__ + "img/apply_scene2.04caae3b.png";